export type HtmlReportAnnotations = {
   rows: HtmlReportRowAnnotation[];
};

export type HtmlReportRowAnnotation = {
   rowId: string;
   highlight: HtmlHighlightAnnotation | null;
   comment: HtmlCommentAnnotation | null;
};

export type HtmlHighlightAnnotation = {
   color?: string | null;
   styleJson?: string | null;
};

export type HtmlCommentAnnotation = {
   text?: string | null;
   updatedAtIso?: string | null;
   mentionsJson?: string | null;
   followUpDateIso?: string | null;
};

export type HtmlReportCommentHistoryItem = {
   eventId: number;
   eventType: string;
   commentText: string;
   actorUserId: number;
   actorDisplayName: string;
   actorEmail?: string | null;
   createdAtIso: string;
};

export type HtmlReportCommentHistoryResponse = {
   items: HtmlReportCommentHistoryItem[];
   hasMore: boolean;
   nextBeforeCreatedAtIso?: string | null;
   nextBeforeEventId?: number | null;
};

export type AddHtmlReportCommentRequest = {
   rowId: string;
   commentText: string;
};

export const EMPTY_HTML_REPORT_ANNOTATIONS: HtmlReportAnnotations = { rows: [] };

export type UpsertHtmlReportAnnotationRequest = {
   rowId: string;
   kind: 'HIGHLIGHT' | 'COMMENT';

   // Highlight
   color?: string | null;

   // Comment
   noteText?: string | null;

   mentionsJson?: string | null;
   followUpDate?: string | null;

   isRemove: boolean;
};
